import axios from "axios"
import { API_BASE_URL, buildHeaders } from "utils/services"

export const fetchMainAction = async (user) => {
    
    try {
        const deposits = axios.get(`${API_BASE_URL}/agbk/deposits/external/list?page=0&status=ON%20HOLD&limit=10`, buildHeaders(user))

        const payouts = axios.get(`${API_BASE_URL}/agbk/payouts/pending/list?compact=1&page=1&limit=1`, buildHeaders(user))


        let response = []

        await axios.all([deposits, payouts]).then(axios.spread((...res) => {
            response = [res[0]?.data?.data?.count, res[1]?.data]
        }))

        return response


    } catch (e) {
        console.log('error main action')
        console.log(e)
        // return [-1, -1, -1, -1, -1]
    }
}